import React from 'react';
import AddEditBlogForm from 'ui-component/blog/AddEditBlogForm';

function AddBlog () {
  return (
    <div>
      <AddEditBlogForm title="Add Blog" />
    </div>
  )
}

export default  AddBlog;